<template>
  <div class="p-6 bg-white overflow-hidden shadow rounded-lg space-y-4">
    <BackButton v-if="backButtonAction" @click="backButtonAction" />
    <div>
      <p class="text-gray-400 mb-5">
        To keep your account secure, we verify your identity. Enter the code
        generated by your authenticator app.
      </p>

      <FormKit
        v-slot="{ state: { valid } }"
        type="form"
        :actions="false"
        :incomplete-message="false"
        form-class="space-y-4"
        @submit="callback"
      >
        <FormKit
          v-model="otp"
          name="otp"
          type="oneTimePassword"
          autofocus="autofocus"
          validation="required"
          label="Verification Code"
          :digits="6"
          :errors="errors"
          :classes="{ size: 'small' }"
        />
        <LoadingButton
          type="submit"
          class="btn btn-primary w-full flex gap-2 items-center"
          :args="{ showSpinner: showSpinnerInSubmitButton }"
          :disabled="!valid"
        >
          Verify
        </LoadingButton>
      </FormKit>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingButton from '~/../member-webapp-shared/components/common/LoadingButton.vue'
import BackButton from '~/../member-webapp-shared/components/common/BackButton.vue'

const otp = defineModel<string>('otp')
const errors = defineModel<string[]>('errors', { default: () => [] })

withDefaults(
  defineProps<{
    callback: () => Promise<void>
    backButtonAction?: () => void
    showSpinnerInSubmitButton?: boolean
  }>(),
  {
    backButtonAction: undefined,
    showSpinnerInSubmitButton: false,
  }
)

watch(otp, () => {
  errors.value = []
})
</script>
